// src/components/DonationModal.js
import React from 'react';
import { Dialog, DialogContent, DialogActions, Button, Box } from '@mui/material';

const DonationModal = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
    <DialogContent sx={{ backgroundColor: '#fff', color: '#000' }}>
      <Box>
        <iframe
          id="kofiframe"
          src="https://ko-fi.com/quantospendo/?hidefeed=true&widget=true&embed=true&preview=true"
          style={{
            border: 'none',
            width: '100%',
            padding: '4px',
            background: '#f9f9f9',
          }}
          height="712"
          title="quantospendo"
        ></iframe>
      </Box>
    </DialogContent>
    <DialogActions>
      <Button 
        onClick={onClose} 
        variant="contained" 
        sx={{ backgroundColor: '#000', color: '#fff' }}
      >
        Chiudi
      </Button>
    </DialogActions>
  </Dialog>
);

export default DonationModal;
